export const SEGMENT_MODES = {
  FIXED_DURATION: 'FIXED_DURATION',
  FIXED_COUNT: 'FIXED_COUNT',
  HIGHLIGHT: 'HIGHLIGHT',
};

export const SEGMENT_MODE_OPTIONS = [
  { value: SEGMENT_MODES.FIXED_DURATION, label: '固定时长' },
  { value: SEGMENT_MODES.FIXED_COUNT, label: '按数量均分' },
];
